// @ts-ignore
import { supabase } from '../supabaseClient'
import { useState, useEffect } from 'react'

export const useNotificationCounts = () => {
    const [counts, setCounts] = useState({
        pendingTickets: 0,
        pendingClients: 0,
    })

    const fetchCounts = async () => {
        const [
            { count: pendingTickets },
            { count: pendingClients },
        ] = await Promise.all([
            supabase
                .from('tickets')
                .select('*', { count: 'exact', head: true })
                .eq('status', 'pending_review'),
            supabase
                .from('client_profiles')
                .select('*', { count: 'exact', head: true })
                .eq('status', 'pending'),
        ])

        setCounts({
            pendingTickets: pendingTickets || 0,
            pendingClients: pendingClients || 0,
        })
    }

    useEffect(() => {
        fetchCounts()

        // تحديث كل 30 ثانية
        const interval = setInterval(fetchCounts, 30000)
        return () => clearInterval(interval)
    }, [])

    return { counts, fetchCounts }
}